import createService from '@/utils/requestBase'
// import configs from '@/config'
export default createService({ baseURL: process.env.VUE_APP_LOGEIN_API, headers: "Authorization", headersData: process.env.VUE_APP_AUTHORIZATION_API })
// iotcenter